import GetData from "@/utils/request.js"

const {
  $get,
  $post
} = new GetData();

// 训练营课程或者私教坊领取带手机号--收集报名信息
export const collectUserInfo= (data) => {
  return $post('/h5/account/update/collectUserInfo',data);
}

// 获取行业信息-新
export const getIndustryNew= () => {
  return $get('/h5/account/getIndustryNew');
}
//获取人员规模
export const getPersonnel= () => {
  return $get('/h5/account/getPersonnel');
}

//获取职业/职位
export const getProfessionNew= () => {
  return $get('/h5/account/getProfessionNew');
}

//营收规模
export const getRevenue= () => {
  return $get('/h5/account/getRevenue');
}

export default {
	collectUserInfo,
	getIndustryNew,
	getPersonnel,
	getProfessionNew,
	getRevenue
}